/**
 * Full-viewport loading state shown by ``AuthGate`` while the session is
 * unresolved. Deliberately mounts nothing of the dashboard shell, so an
 * unauthenticated visitor never sees it flash before the redirect (§1.5).
 */

import { Spinner } from "@/components/ui/spinner"

export function FullScreenLoader() {
  return (
    <div
      aria-busy="true"
      data-testid="full-screen-loader"
      className="min-h-screen bg-background flex items-center justify-center"
    >
      <Spinner className="size-8 text-muted-foreground" />
    </div>
  )
}
